import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const SkeletonCard = styled(Box)`
  ${({ theme }) => css`
    border: 1px solid ${theme.colors.border.light};
    border-radius: 10px;
    padding: 24px;
    background: ${theme.colors.lightest};
  `}
`

export const SkeletonHeader = styled(Box)`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid ${theme.colors.border.light};
  `}
`

export const SkeletonTitle = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`

export const SkeletonActions = styled(Box)`
  display: flex;
  gap: 8px;
`

export const SkeletonContent = styled(Box)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
`

export const SkeletonField = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const SkeletonLine = styled.div<{ width?: string; height?: string }>`
  ${({ theme, width = '100%', height = '16px' }) => css`
    width: ${width};
    height: ${height};
    background: linear-gradient(90deg, ${theme.colors.border.light} 25%, #f0f0f0 50%, ${theme.colors.border.light} 75%);
    background-size: 200% 100%;
    animation: loading 1.5s infinite;
    border-radius: 4px;

    @keyframes loading {
      0% {
        background-position: 200% 0;
      }
      100% {
        background-position: -200% 0;
      }
    }
  `}
`
